<template>
  <div class="section">
    <NavigationSection :sectionId="sectionId" />
    <section class="block">
      <p class="booth">
        <img
          :src="require('@/assets/images/booth/' + $route.params.id + '.jpg')"
          width="97%"
          alt="booth"
        />
      </p>
      <ul>
        <!-- main icon -->
        <li class="btn-mov">
          <p class="btn_opn mov12_1">
            <img
              src="@/assets/images/common/icon_mov.png"
              width="50px"
              alt="mov"
            />
          </p>
          <div class="mov_wrapper">
            <iframe
              class="mov"
              src="https://www.youtube.com/embed/KD6kjH6pcJY"
              frameborder="0"
              allow="autoplay; encrypted-media"
              allowfullscreen
            ></iframe>
          </div>
        </li>
        <li>
          <a href="javascript:void(0);">
            <p class="btn_opn web12_1">
              <img
                src="@/assets/images/common/icon_web.png"
                width="50px"
                alt="pdf"
              />
            </p>
            <p class="photo">
              <img
                :src="
                  require('@/assets/images/panel/' +
                    $route.params.id +
                    '/web_27.png')
                "
                width="100%"
                alt=""
              />
            </p>
            <p class="name">web12_1</p>
          </a>
        </li>
        <!-- sub icon -->
        <li>
          <a href="javascript:void(0);">
            <p class="btn_opn pdf12_1">
              <img
                src="@/assets/images/common/icon_pdf.png"
                width="40px"
                alt="pdf"
              />
            </p>
            <p class="photo">
              <img
                :src="
                  require('@/assets/images/panel/' +
                    $route.params.id +
                    '/2_9_11_2.png')
                "
                width="100%"
                alt=""
              />
            </p>
            <p class="name">pdf12_1</p>
          </a>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
import NavigationSection from '@/components/NavigationSection.vue';
import SelectIcon from '@/mixins/SelectIcon.js';

export default {
  name: 'Section12',
  components: { NavigationSection },
  mixins: [SelectIcon],
  data() {
    return {
      sectionId: 12
    };
  }
};
</script>

<style scoped>
.mov12_1 {
  position: absolute;
  top: 25px;
  left: 20px;
}
.web12_1 {
  position: absolute;
  top: 25px;
  left: 75px;
}
.pdf12_1 {
  position: absolute;
  top: 39%;
  left: 68%;
}
</style>
